import { render, staticRenderFns } from "./MemberPrincipal.vue?vue&type=template&id=30022a70&scoped=true&"
import script from "./MemberPrincipal.vue?vue&type=script&lang=js&"
export * from "./MemberPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./MemberPrincipal.vue?vue&type=style&index=0&id=30022a70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30022a70",
  null
  
)

export default component.exports